import Skeleton from '@material-ui/lab/Skeleton';
import React from 'react';
import { useIntl } from 'react-intl';

import { TXTCLI_LoadingXX } from './SkeletonFeaturedWidget.messages.json';
import styles from './SkeletonFeaturedWidget.scss';

const SkeletonIconLink: React.FC = () => (
  <div className={styles.iconLink}>
    <Skeleton variant="rect" height="21px" width="21px" animation="pulse" />
    <Skeleton variant="rect" height="21px" width="200px" animation="pulse" />
  </div>
);

export default () => {
  const { formatMessage } = useIntl();

  return (
    <div role="status" aria-label={formatMessage(TXTCLI_LoadingXX)} aria-live="polite">
      <Skeleton variant="rect" height="48px" width="100%" animation={false} />
      <SkeletonIconLink />
      <SkeletonIconLink />
      <SkeletonIconLink />
      <SkeletonIconLink />
      <SkeletonIconLink />
    </div>
  );
};
